module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/payroll-authorize/payroll-authorize-grid/payroll-authorize-grid.component.css
// module id = ./src/app/hrms/payroll/payroll-authorize/payroll-authorize-grid/payroll-authorize-grid.component.css
// module chunks = main